export interface DropdownSelection {
  value: string;
  isChange: boolean;
}

/**
 * Reads what a single-select Northstar Dropdown passed to onChange: the chosen item, or null when
 * the field was cleared (Dropdown.js computes `proposedValue[0] || null`).
 *
 * isChange is false when the pick equals the value already committed. Consumers answer a change by
 * resetting the fields that depend on it, so committing a no-op silently clears the rest of a row.
 */
export const readSelection = (
  selectedItem: DropdownDataModel,
  field: 'key' | 'value',
  committedValue: string
): DropdownSelection => {
  const value = selectedItem ? selectedItem[field] ?? '' : '';

  return { value, isChange: value !== committedValue };
};
